<template>
  <v-form lazy-validation>
    <v-layout row wrap xs12>
      <!-- debut dialog -->
      <v-dialog v-model="dialog" max-width="50%">
        <template v-slot:activator="{ on }">
          <v-layout class="btn-dialog" align-start justify-end>
            <v-btn
              dark
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              v-on="on"
              color="ecSecondary"
              @click="Ajouter"
            >
              {{ $storeUm6p.Label.Ajouter }}
            </v-btn>
          </v-layout>
        </template>
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-toolbar color="ecSecondary" dark>
              <v-toolbar-title>{{
                $storeUm6p.Label.Title.Bourse
              }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col col="6">
                    <v-text-field
                      v-model="$storeBourse.editedItem.organisme"
                      :rules="$storeReglesBourse.obligatoire"
                      :label="$storeUm6p.Label.Candidat.NomAutreBourse"
                      class="asterisk"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col col="6"> </v-col>
                </v-row>
                <v-row>
                  <v-col col="6">
                    <v-menu
                      v-model="menu.dateDebut"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          clearable
                          v-model="DateDebutFormated"
                          :label="$storeUm6p.Label.Candidat.DateDebutBourse"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="$storeBourse.editedItem.debut = null"
                        />
                      </template>
                      <v-date-picker
                        v-model="$storeBourse.editedItem.debut"
                        @input="menu.dateDebut = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col col="6">
                    <v-menu
                      v-model="menu.dateFin"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          clearable
                          v-model="DateFinFormated"
                          :label="$storeUm6p.Label.Candidat.DateFinBourse"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="$storeBourse.editedItem.fin = null"
                        />
                      </template>
                      <v-date-picker
                        v-model="$storeBourse.editedItem.fin"
                        @input="menu.dateFin = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col col="3">
                    <VuetifyMoney
                      v-model="$storeBourse.editedItem.montantDirham"
                      :label="$storeUm6p.Label.Candidat.MontantAnnuelDirham"
                      v-bind:readonly="readonly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="optionsDH"
                    />
                  </v-col>
                  <v-col col="3"></v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small dark color="ecSecondary" @click="close">{{
                $storeUm6p.Label.Annuler
              }}</v-btn>
              <v-btn small dark color="ecSecondary" @click="save">{{
                $storeUm6p.Label.Valider
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- fin dialog -->
    </v-layout>
    <!-- Début Liste langues -->
    <v-data-table
      :headers="$storeUm6p.Label.Bourse.HeadersTab"
      :items="$storeBourse.DonneesFormulaireEC.listeAutresBourses"
      @current-items="ListeAutresBourses"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.supprimer">
          <th class="text-xs-left">{{ item.organisme }}</th>
          <th class="text-xs-left">
            {{ $storeBourse.FormatDate(item.debut) }}
          </th>
          <th class="text-xs-left">{{ $storeBourse.FormatDate(item.fin) }}</th>
          <th class="text-xs-left">{{ item.montantDirham }}</th>
          <th>
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiPencil }}</v-icon
            >
            <v-icon
              small
              @click="deleteItem(item)"
              v-show="!$storeBourse.DonneesFormulaireEC.readOnly"
              >{{ icons.mdiDelete }}</v-icon
            >
          </th>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>
<script>
import { mdiPencil, mdiDelete } from "@mdi/js";
import VuetifyMoney from "../VuetifyMoney";

export default {
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      // Param des rubriques revenus
      label: "",
      readonly: false,
      disabled: false,
      outlined: true,
      clearable: false,
      optionsDH: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },
      menu: {
        dateDebut: false,
        dateFin: false,
      },
      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeBourse: this.$storeBourse,
      // dialog pour ouvrir/fermer la popup
      dialog: false,

      // Validation du formulaire
      valid: false,
      blankItem: {
        idCrypte: null,
        supprimer: false,
        organisme: null,
        debut: null,
        fin: null,
        montantDirham: null,
      },
    };
  },
  mounted() {},
  computed: {
    DateDebutFormated() {
      return this.$storeBourse.FormatDate(this.$storeBourse.editedItem.debut);
    },
    DateFinFormated() {
      return this.$storeBourse.FormatDate(this.$storeBourse.editedItem.fin);
    },
  },
  methods: {
    Ajouter() {
      this.$storeBourse.editedItem = Object.assign({}, this.blankItem);
    },
    ListeAutresBourses() {
      return this.$storeBourse.DonneesFormulaireEC.listeAutresBourses;
    },
    validation() {
      if (
        this.$storeBourse.DonneesFormulaireEC.bourseSupplementaire ===
          this.$storeCatalogue.DataId.Oui && (!this.$storeBourse.DonneesFormulaireEC.listeAutresBourses ||
        this.$storeBourse.DonneesFormulaireEC.listeAutresBourses.length < 1)
      ) {
        return false;
      }

      return true;
    },
    editItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.$storeBourse.editItem(
        item,
        this.$storeBourse.DonneesFormulaireEC.listeAutresBourses
      );
      // ouvre le popup
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
        this.$storeBourse.DonneesFormulaireEC.listeAutresBourses =
          this.$storeBourse.deleteItem(
            item,
            this.$storeBourse.DonneesFormulaireEC.listeAutresBourses
          );
      }
    },
    close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();

      // ferme le popup
      this.dialog = false;

      this.$storeBourse.close(this.blankItem);
    },
    save() {
      // validation du formulaire
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.$storeBourse.DonneesFormulaireEC.listeAutresBourses = this.$storeBourse.DonneesFormulaireEC.listeAutresBourses ?? [];
      this.$storeBourse.save(
        this.$storeBourse.DonneesFormulaireEC.listeAutresBourses
      );
      // on appelle close pour raz l'item local + fermer le popup
      this.close();
    },
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
